import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'app/shared/models/subject';
import { SubjectLink } from 'app/shared/models/subject-link';
import { SubjectLinkService } from 'app/shared/services/subject-link.service';

@Component({
  selector: 'subject-list',
  templateUrl: './subject-list.component.html',
  styleUrls: ['./subject-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SubjectListComponent {

  @Input() subjects: Subject[] | SubjectLink[];
  @Input() readOnly = false;
  @Input() admin = false;
  @Input() allowEdit = false;
  @Input() allowDelete = false;
  @Input() allowEditRelationship = false;
  @Input() allowSelect = true;
  @Input() noContentMessage = 'There are no subjects';
  
  @Output() onSelect: EventEmitter<any> = new EventEmitter();
  @Output() onEdit: EventEmitter<any> = new EventEmitter();
  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() onChangeRelationship: EventEmitter<any> = new EventEmitter();

  constructor(private subjectLinkService: SubjectLinkService, private dialog: MatDialog) { }

  select(subjectLink) {
    this.subjectLinkService.onSelected.next(subjectLink);
    this.onSelect.emit(subjectLink);
  }

  edit(subjectLink){
    this.onEdit.emit(subjectLink);
  }

  delete(subjectLink){
      this.onDelete.emit(subjectLink);
  }

  changeRelationship(link){
    if (this.allowEditRelationship){
      this.onChangeRelationship.emit(link);
    }
  }

  trackByFn(index, item){
    return item.id;
  }
}
